module.exports = __webpack_public_path__ + "img/notification-icon.bc88651a.svg";